import CountryPageTemplate from './CountryPageTemplate';

export default function BulgariaPage() {
  return <CountryPageTemplate countryKey="bg" />;
}